import { BaseWebComponentRepository } from '../../../framework/BaseWebComponentRepository';
import { MisconfigurationsAppDataProviderFactory } from '../factory/MisconfigurationsAppDataProviderFactory';
import { MisconfigurationsAppBaseDataProvider } from '../dataProvider/MisconfigurationsAppBaseDataProvider';
import { MisconfigurationsAppWebComponentSchema } from '../types';

export class MisconfigurationsAppRepository extends BaseWebComponentRepository {
  public dataProviderFactory: MisconfigurationsAppDataProviderFactory;
  public dataProvider: MisconfigurationsAppBaseDataProvider;

  constructor() {
    super();
    this.initialSetup({
      dataProviderFactory: new MisconfigurationsAppDataProviderFactory(),
    });
  }

  async getDataForView(): Promise<MisconfigurationsAppWebComponentSchema> {
    return this.dataProvider.getDataForView();
  }
}
